// @flow
import * as React from 'react';

import { JsonLd } from 'react-schemaorg';
import type { Organization } from '../types';

export const organizationDef: Organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Yapita Health PVT LTD',
  url: 'https://yapitahealth.com',
  logo: 'https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-health-logo.png',
  description: 'Yapita Health assist you in making the right health decisions through our network of global doctors and hospitals.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '513 Ocus Quantum',
    addressLocality: 'Gurugram',
    addressRegion: 'Haryana',
    postalCode: '122001',
    addressCountry: 'India'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+918056005099',
    contactType: 'Customer Service',
    areaServed: 'Worldwide',
    availableLanguage: ['English', 'Arabic']
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '1289'
  },
  sameAs: [
    'https://www.facebook.com/yapitahealth/',
    'https://x.com/yapitahealth',
    'https://www.instagram.com/yapitahealth/',
    'https://www.linkedin.com/company/yapitahealth',
    'https://www.youtube.com/@yapitahealth1140'
  ]
};

const OrganizationDef = (): React.Node => <JsonLd item={organizationDef} />;

export default OrganizationDef;
